import { Icon } from "@rmwc/icon"
import "@rmwc/icon/styles"

const IconComponent = <Icon icon="restore" />

export const RestoreIcon = IconComponent
